import { FunctionComponent } from 'react'
import styles from './staffHome.module.scss'
import Title from '@/components/_custom/Title/title'
import ProfileIcon from '@mui/icons-material/AccountCircle'
import { useTranslation } from 'react-i18next'
import LockReset from '@mui/icons-material/LockReset'
import Notifications from '@mui/icons-material/Notifications'
import TranslateIcon from '@mui/icons-material/Translate'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import House from '@mui/icons-material/House'
import { useAuth } from '@/modules/context/AuthContext'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import ArticleIcon from '@mui/icons-material/Article'
import HelpIcon from '@mui/icons-material/Help'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import HomeCase from '../HomeCase/homeCase'

interface StaffHomeDesktopProps {
    daycareTypeName: string
    backendVersion: string
    frontendVersion: string
    setDialogChangeLanguageOpen: (open: boolean) => void
    setDialogForgottenPasswordOpen: (open: boolean) => void
    setDialogSupportOpen: (open: boolean) => void
}

const StaffHomeDesktop: FunctionComponent<StaffHomeDesktopProps> = ({
    daycareTypeName,
    backendVersion,
    frontendVersion,
    setDialogChangeLanguageOpen,
    setDialogForgottenPasswordOpen,
    setDialogSupportOpen
}: StaffHomeDesktopProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.PagePosition}>
            <div className={styles.HomePlacement}>
                <Title text={t('myAccount')} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={daycareTypeName}
                        icon={<House className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/daycare')}
                    />
                    <HomeCase
                        text={t('myProfile')}
                        icon={<ProfileIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/account/profile')}
                    />
                    <HomeCase
                        text={t('myAlerts')}
                        icon={<Notifications className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/account/notifications')}
                    />
                </div>
            </div>
            <div className={styles.HomePlacement}>
                <Title text={t('settings')} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('language')}
                        icon={<TranslateIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => setDialogChangeLanguageOpen(true)}
                    />
                    <HomeCase
                        text={t('password')}
                        icon={<LockReset className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => setDialogForgottenPasswordOpen(true)}
                    />
                    <HomeCase text={t('logout')} icon={<LogoutIcon className={styles.CaseIcon} />} onClick={logout} />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('ourArticles')}
                        icon={<ArticleIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/nos-articles/'}
                    />
                    <HomeCase
                        text={t('help')}
                        icon={<HelpIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/aide-structure'}
                    />
                    <HomeCase
                        text={t('refresh')}
                        icon={<CachedIcon className={styles.CaseIcon} />}
                        onClick={removeServiceWorker}
                    />
                </div>
            </div>
            <div className={styles.Version}>
                <a onClick={() => setDialogSupportOpen(true)}>
                    V{backendVersion}/{frontendVersion}
                </a>
            </div>
        </div>
    )
}

export default StaffHomeDesktop
